(function($) {

	'use strict';

	var init = function() {

        SliderGallery();
        addClassVideo();
        addSpanButton();
        spacingTimeline();

	};

	var SliderGallery = function() {
        $(window).resize(function() {
            if($(window).width() > 767) {
                $('.flex-gallery__wrapper').trigger('destroy.owl.carousel');
                $('.flex-gallery__wrapper').addClass('flex-gallery__flex');
                $('.flex-gallery__wrapper').removeClass('owl-carousel');
                if($('.flex-gallery__item').length < 3) {
                    $('.flex-gallery__wrapper').addClass('flex-gallery__center');
                    $('.flex-gallery__item').addClass('Small');
                } else {
                    $('.flex-gallery__item').addClass('Big');
                }
            } else {
                $('.flex-gallery__wrapper').addClass('owl-carousel');
                $('.flex-gallery__wrapper').removeClass('flex-gallery__flex');
                $('.flex-gallery__wrapper').owlCarousel({
                    loop: false,
                    center: true,
                    items: 1,
                    margin: 15,
                    autoWidth: true,
                    dots: true,
                    touchDrag: true,
                    dotsEach: 2,
                    smartSpeed: 700,
                });
            }
        }).resize();
    }

    var addClassVideo = function() {
        $('.flex-column iframe').parent().addClass('video');
    }

    var addSpanButton = function() {
        $('.button').wrapInner('<span></span>');
    }

    var addButtonForm = function() {
        $('.gform_button').wrap('<div class="button button--dark"></div>');
    }

    var spacingTimeline = function() {
        
        $(window).resize(function() {
            if($(window).width() > 767) {
                $('.flex-timeline__item').each(function() {
                    var height = $(this).height();
                    $(this).next().css('margin-top', '-'+ height/2 +'px');
                });
            } else {
                $('.flex-timeline__item').css('margin-top','0');
            }
        }).resize();

    }

	$(document).ready(function() {
        init();
    });
    
    $(document).on('gform_post_render', function(){
        addButtonForm();
    });

})(jQuery);
